//http://localhost:9301/system/mch/list


import axios from "axios";
import {Message} from "element-ui";

const aSystemService = axios.create({
  baseURL: 'https://yitongservice.njrentong.com', // 如 http://192.168.1.100:8080/dev-api
  timeout: 5000 // 超时时间
});


aSystemService.interceptors.request.use(
  config => {
    const token = localStorage.getItem('Admin-Token');
    if (token) {
      config.headers['authorization'] = token; // 与A系统后端约定的Token头键名
    }
    return config;
  },
  error => {
    Message.error('调用A系统接口失败（网络错误）');
    return Promise.reject(error);
  }
);


// 响应拦截器：简化A系统的响应处理
aSystemService.interceptors.response.use(
  response => {
    const res = response.data;
    // A系统接口约定：code=200为成功（Token有效），其他为失败
    if (res.code !== 200) {
      return Promise.reject(new Error(res.msg || 'Token验证失败'));
    }
    return res;
  },
  error => {
    // A系统直接返回401状态码（Token无效/过期）
    if (error.response && error.response.status === 401) {
      return Promise.reject(new Error('Token已过期或无效'));
    }
    Message.error('该账号无权限');
    return Promise.reject(error);
  }
);


export const validateToken = () => {

  return aSystemService.get('/sys/park/robotQuanxian'); // A系统验证Token的接口（无需传参，仅靠头信息）
};
